
// whether this is dev.lingoleaf.io
const IS_DEV_FRONTEND = window.location.href === 'https://dev.lingoleaf.io/' || window.location.href.startsWith('https://dev.lingoleaf.io')

// number of hints when you start leaf
const INITIAL_HINT_COUNT = 8;

// if tree has this week index or lower, then warning banner displayed
const EARLY_CONTENT_WARNING_WEEK = 5;

const LANGUAGE_NAMES = {
    'en': 'English',
    'de': 'Deutsch',
    'fr': 'Français',
    'es': 'Español',
    'ja': '日本語',
    'hi': 'हिन्दी',
}
const LEVEL_NAMES = {
  'beg': 'Beginner',
  'int': 'Intermediate',
  'adv': 'Advanced',
}

// set PADDLE_LIVE according to where frontend is hosted
let PADDLE_LIVE;
if (process.env.NODE_ENV==='development') {
  PADDLE_LIVE = false;
} else if (IS_DEV_FRONTEND) {
  PADDLE_LIVE = false;
} else {
  PADDLE_LIVE = true;
}
const PADDLE_SANDBOX_CLIENT_TOKEN = "test_771ed15bf5b411058ef171dd05c"
const PADDLE_LIVE_CLIENT_TOKEN = "live_7611d833c8cf1b6b135a5370555"
const PADDLE_SANDBOX_PRICE_ID = "pri_01jer1xmaq0jz0y6gee8jf1v1m"
const PADDLE_SANDBOX_PRICE_ID_NO_TRIAL = "pri_01jhmjm37mbk5na6wc43hn92bk"
const PADDLE_LIVE_PRICE_ID = "pri_01jer27ykgvnnym2m108v7hngs"
const PADDLE_LIVE_PRICE_ID_NO_TRIAL = "pri_01jhmjs7s71sgnqk104ymndhvw"
const PADDLE_PRICE_ID = PADDLE_LIVE ? PADDLE_LIVE_PRICE_ID : PADDLE_SANDBOX_PRICE_ID
const PADDLE_PRICE_ID_NO_TRIAL = PADDLE_LIVE ? PADDLE_LIVE_PRICE_ID_NO_TRIAL : PADDLE_SANDBOX_PRICE_ID_NO_TRIAL
const PADDLE_CLIENT_TOKEN = PADDLE_LIVE ? PADDLE_LIVE_CLIENT_TOKEN : PADDLE_SANDBOX_CLIENT_TOKEN

export { IS_DEV_FRONTEND, INITIAL_HINT_COUNT, EARLY_CONTENT_WARNING_WEEK, LANGUAGE_NAMES, LEVEL_NAMES, PADDLE_LIVE, PADDLE_PRICE_ID, PADDLE_PRICE_ID_NO_TRIAL,PADDLE_CLIENT_TOKEN }